<template>
    <div class="home_3">
      <thirdstepGrooming></thirdstepGrooming>
    </div>
</template>
  
<script>
  // @ is an alias to /src
  import thirdstepGrooming from '@/components/fourthstepGrooming.vue'
  
  export default {
    name: 'fourthstepGroomingView',
    components: {
        thirdstepGrooming
    }
  }
</script>
  
  <style scoped>
    .home_3{
      display: flex;
      justify-content: center;
      padding-top: 7vh;
      
    }
  </style>
  